import { defineMessages } from 'react-intl';

export const organizationStaffMessages = defineMessages({
  tab: {
    id: 'organizationStaff.tab',
    defaultMessage: 'Staff',
  },
  searchPlaceholder: {
    id: 'organizationStaff.searchPlaceholder',
    defaultMessage: 'Search by name, email, specialization, or access level',
  },
  colName: {
    id: 'organizationStaff.col.name',
    defaultMessage: 'Name',
  },
  colEmail: {
    id: 'organizationStaff.col.email',
    defaultMessage: 'Email',
  },
  colSpecialization: {
    id: 'organizationStaff.col.specialization',
    defaultMessage: 'Specialization',
  },
  colAccessLevel: {
    id: 'organizationStaff.col.accessLevel',
    defaultMessage: 'Access level',
  },
  colRegistration: {
    id: 'organizationStaff.col.registration',
    defaultMessage: 'Registration',
  },
  colStatus: {
    id: 'organizationStaff.col.status',
    defaultMessage: 'Status',
  },
  registered: {
    id: 'organizationStaff.registered',
    defaultMessage: 'Registered',
  },
  statusActive: {
    id: 'organizationStaff.status.active',
    defaultMessage: 'Active',
  },
  statusDeleted: {
    id: 'organizationStaff.status.deleted',
    defaultMessage: 'Deleted',
  },
  notRegistered: {
    id: 'organizationStaff.notRegistered',
    defaultMessage: 'Not registered',
  },
  noStaff: {
    id: 'organizationStaff.noStaff',
    defaultMessage: 'No staff members',
  },
});
